import axios from "axios";
import { connections } from "./Paths";

const apiConnection = axios.create({
    baseURL: connections.urlDev,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor de respuestas para manejo centralizado de errores
apiConnection.interceptors.response.use(
    response => response, // Si no hay error, simplemente retorna la respuesta
    error => {
        if (error.response) {
            const { status, config } = error.response;

            switch (status) {
                case 400:
                    console.error('⚠️ Solicitud incorrecta (400)', config.url);
                    break;
                case 401:
                    console.error('🔒 No autorizado (401)', config.url);
                    break;
                case 403:
                    console.error('🚫 Acceso prohibido (403)', config.url);
                    break;
                case 404:
                    console.warn('⚠️ Recurso no encontrado (404)', config.url);
                    break;
                case 500:
                    console.error('💥 Error interno del servidor (500)', config.url);
                    break;
                default:
                    console.error(`❗ Error no controlado (${status})`, config.url);
            }
        } else {
            // El error puede ser por problemas de red o sin respuesta del servidor
            console.error('❌ Error de red o el servidor no respondió:', error.message);
        }

        return Promise.reject(error); // Permite manejarlo en el .catch o try/catch
    }
);

export default apiConnection;
